export function NavDropDownOptions({ children }) {
  return <div className="nav__dropdown-option">{children}</div>;
}
